<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<div class="row">
				<div class="col-md-12 text-right">
					<a-button class="btn btn-primary" icon="plus" @click="onAddRecord">Nuevo producto</a-button>
					<a-button class="btn btn-primary ml7" @click="getAllProducts">Carga todos</a-button>
				</div>
			</div>
			<div class="row pt10">
				<div class="col-md-12">
					<a-input-search v-model="searchText" ref="searchInput" placeholder="Ingresa SKU o nombre de producto para buscar en el catálogo" enter-button @search="onSearch" />
				</div>
			</div>
			<div class="row pt20" v-if="productsList.length">
				<div class="col-md-12">
					<a-table :columns="columns" :dataSource="productsList" rowKey="id" :scroll="{ x: 1000 }">
						<div slot="product_label" slot-scope="record">
							{{ record.label }}
							<a-tag v-if="record.is_service === 'true' || record.is_service === true" color="blue" class="ml-2">Servicio</a-tag>
							<div>
								<b>{{ record.sku }}</b>
							</div>
						</div>
						<span slot="stock" slot-scope="record">
							<!-- <a-tag :color="record.COD_ALM == 'A001' ? 'green' : 'yellow'"> Producto {{ record.COD_ALM == 'A001' ? 'pintado' : 'por pintar' }} </a-tag> -->
							<div>{{ record.stock }}</div>
						</span>
						<!-- <span slot="price_bronze" slot-scope="text, record"> --- </span> -->
						<span slot="price_bronze" slot-scope="record"> {{ numeral(record.price_bronze).format('$0,0') }} </span>
						<span slot="price_silver" slot-scope="record"> {{ numeral(record.price_silver).format('$0,0') }} </span>
						<span slot="price_gold" slot-scope="record"> {{ numeral(record.price_gold).format('$0,0') }} </span>
						<span slot="public_price" slot-scope="record"> {{ numeral(record.public_price).format('$0,0') }} </span>

						<span slot="action" slot-scope="record">
							<a-button class="btn" size="small" icon="edit" @click="onEditRecord(record.id)" />
							<!-- <a-button class="btn btn-success ml7" size="small" icon="plus" @click="onAddProduction(record.id)" /> -->
							<a-button class="btn btn-info ml7" size="small" icon="printer" @click="onPrintLabel(record)" />
						</span>
					</a-table>
				</div>
			</div>
		</a-spin>
		<div id="printLabel" style="align: center" v-show="false">
			<table border="0" width="350mm">
				<tr>
					<td colspan="2" align="center">
						<br />
						<div><img src="resources/images/logo.png" height="40" /></div>
						<barcode :value="selectedProduct.sku" width="2" height="45" fontSize="12"></barcode>
						<div style="font-size: 10pt !important">
							{{ selectedProduct.label }}
						</div>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
//
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import _ from 'lodash'
import numeral from 'numeral'
import VueBarcode from 'vue-barcode'
import VueHtmlToPaper from 'vue-html-to-paper'
import utilities from '@/services/utilities'
import moment from 'moment'
import copy from 'copy-to-clipboard'

const options = {
	name: '_blank',
	specs: ['fullscreen=yes', 'titlebar=no', 'scrollbars=no'],
	styles: ['resources/css/printLabels.css'],
	timeout: 1500, // default timeout before the print window appears
	autoClose: true, // if false, the window will not close after printing
	windowTitle: '', // override the window title
}

Vue.use(VueHtmlToPaper, options)

export default {
	name: 'productsList',
	components: {
		barcode: VueBarcode,
	},
	data() {
		return {
			searchText: '',
			columns: [
				{
					title: 'Nombre del producto',
					scopedSlots: { customRender: 'product_label' },
					width: 300,
				},
				{
					title: 'Stock',
					align: 'center',
					scopedSlots: { customRender: 'stock' },
					width: 100,
				},
				{
					title: 'Precio Bronce',
					align: 'center',
					scopedSlots: { customRender: 'price_bronze' },
					width: 120,
				},
				{
					title: 'Precio Plata',
					align: 'center',
					scopedSlots: { customRender: 'price_silver' },
					width: 120,
				},
				{
					title: 'Precio Oro',
					align: 'center',
					scopedSlots: { customRender: 'price_gold' },
					width: 120,
				},
				{
					title: 'Precio Público',
					align: 'center',
					scopedSlots: { customRender: 'public_price' },
					width: 120,
				},
				{
					title: 'Acciones',
					scopedSlots: { customRender: 'action' },
					align: 'right',
					width: 120,
					fixed: 'right',
				},
			],
			apiURL: process.env.VUE_APP_API_URL,
			selectedProduct: {
				label: '',
				sku: '',
				sale_price: '',
			},
		}
	},
	destroyed() {
		this.$store.commit('products/SET_STATE', {
			productsList: [],
		})
	},
	computed: {
		...mapGetters('user', ['user']),
		...mapGetters('products', ['productsList']),
		spinnerLoaderLabel() {
			return this.$store.state.products.spinnerLoaderLabel
		},
		spinnerLoader() {
			return this.$store.state.products.spinnerLoader
		},
		usersAllowed() {
			return [1, 3].includes(this.user.user_id)
		},
	},
	methods: {
		numeral,
		getAllProducts() {
			this.$store.dispatch('products/GET')
		},
		getStockReport() {
			this.$store.commit('products/SET_STATE', {
				spinnerLoaderLabel: 'Obteniendo información',
				spinnerLoader: true,
			})

			this.$store.dispatch('warehouse/GET_STOCK_REPORT').then((response) => {
				// console.log('GET_STOCK_REPORT::response-->', response)
				window.open(`${process.env.VUE_APP_API_URL}/public/${response.data[0].filePath}`)
				setTimeout(() => {
					window.open(`${process.env.VUE_APP_API_URL}/public/${response.data[1].filePath}`)
					this.$store.commit('products/SET_STATE', {
						spinnerLoader: false,
					})
				}, 1500)
			})
		},
		onCreateSKU() {
			copy(moment().valueOf())
			Vue.prototype.$notification.success({
				message: `Generador de SKU's`,
				description: 'SKU generado y copiado de manera correcta',
			})
		},
		onAddRecord() {
			this.$router.push('/warehouse/products/create')
		},
		onEditRecord(id) {
			this.$store.dispatch('products/GET_ONE', { id })
		},
		onToggleRecord(id, status) {
			Swal.fire({
				title: 'Atención',
				text: `¿Desea ${status ? 'deshabilitar' : 'habilitar'} el registro?`,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Sí, continuar',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					this.$store.dispatch('products/TOGGLE', id)
				}
			})
		},
		onSearch() {
			if (this.searchText == '') {
				Swal.fire({
					title: 'Catálogo de Productos',
					text: 'Debes ingresar texto para la búsqueda',
					icon: 'warning',
					confirmButtonText: 'Ok',
				})
			} else {
				this.$store.dispatch('products/SEARCH', { searchText: this.searchText })
			}
		},
		onAddProduction(id) {
			Swal.fire({
				title: 'Registro de Producción',
				text: 'Ingresa la cantidad de productos producidos',
				input: 'text',
				showCancelButton: true,
				confirmButtonText: 'Continuar',
				cancelButtonText: 'Cancelar',
				confirmButtonColor: '#41b883',
				cancelButtonColor: '#f5222e',
				reverseButtons: true,
				inputAttributes: {
					autocorrect: 'off',
					autocomplete: 'off',
				},
				inputValidator: (value) => {
					return new Promise((resolve) => {
						if (isNaN(value)) {
							resolve('Ingresa valor correcto')
						}
						resolve()
					})
				},
			}).then((result) => {
				if (result.isConfirmed) {
					this.$store
						.dispatch('warehouse/PRODUCTION', {
							id,
							quantity: numeral(result.value).value(),
						})
						.then(() => {
							this.$store.dispatch('products/GET')
						})
				}
			})
		},
		onPrintLabel(record) {
			this.selectedProduct = {
				label: record.label,
				sku: record.sku,
				sale_price: record.normal_price,
			}
			setTimeout(() => {
				this.$htmlToPaper('printLabel')
			}, 100)
		},
		getSalePrice(record) {
			let prices = JSON.parse(record)
			return numeral(prices.sale_price).format('$0,0.00')
		},
		getTieredPrice(record, tier) {
			let prices = record.prices
			if (!prices) return '---'
			if (typeof prices === 'string') {
				prices = JSON.parse(prices)
			}
			return prices[tier] ? numeral(prices[tier]).format('$0,0') : '---'
		},
		getWCLink(path) {
			if (path.includes('variations')) {
				path = utilities.replaceText(path.split('variations')[0], '/', '')
			}
			return `https://shieldmoto.mx/?page_id=${path}`
		},
	},
}
</script>

<style scoped>
.ml7 {
	margin-left: 7px;
}
.pt10 {
	padding-top: 10px;
}
.pt20 {
	padding-top: 20px;
}
/* Ensure the table doesn't overflow its container on small screens */
.ant-table-wrapper {
	width: 100%;
	overflow-x: auto;
}

@media (max-width: 576px) {
	.text-right {
		text-align: left !important;
		margin-top: 10px;
	}
	.btn {
		width: 100%;
		margin-bottom: 10px;
		margin-left: 0 !important;
	}
}
</style>
